/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/10/30
 */
import React from 'react';

const Prev = () => {
  return <svg viewBox="0 0 1024 1024" className="store-svg-prev">
    <path d="M245.87377778 562.40355555c-27.07911111-26.96533333-27.648-70.20088889-0.91022223-96.82488888L680.96 30.15111111c26.624-26.624 69.97333333-26.39644445 96.59733333 0.22755556l1.13777778 1.13777778c26.73777778 26.73777778 26.624 69.85955555-0.22755556 96.48355555l-390.37155555 385.70666667 390.37155555 385.024c26.85155555 26.51022222 26.96533333 69.06311111-0.34133333 95.45955555-27.07911111 26.28266667-70.54222222 26.16888889-98.07644444-1.25155555L245.87377778 562.40355555z"/>
  </svg>
};

export default Prev;



// WEBPACK FOOTER //
// ./src/svgs/prev.js